import {
  INTRODUCING_BROKER_ACCOUNT_COMMISSION_ROUTE,
  INTRODUCING_BROKER_APPLY_ROUTE,
  INTRODUCING_BROKER_CLIENT_COMMISSION_ROUTE,
  INTRODUCING_BROKER_COMMISSION_SETTINGS_ROUTE,
  INTRODUCING_BROKER_DASHBOARD_ROUTE,
  INTRODUCING_BROKER_IB_COMMISSIONS_ROUTE,
  INTRODUCING_BROKER_LINKS_ROUTE,
  INTRODUCING_BROKER_PERFORMANCE_DASHBOARD_ROUTE,
  INTRODUCING_BROKER_ROUTE,
} from "_constants";
import { lazy } from "react";

const IntroducingBroker = lazy(() => import("pages/introducing-broker"));
const IntroducingBrokerApply = lazy(() =>
  import("pages/introducing-broker/apply")
);
const IntroducingBrokerDashboard = lazy(() =>
  import("pages/introducing-broker/dashboard")
);
const IntroducingBrokerAccountCommission = lazy(() =>
  import("pages/introducing-broker/account-commission")
);
const IntroducingBrokerClientCommission = lazy(() =>
  import("pages/introducing-broker/client-commission")
);

const IntroducingBrokerLinks = lazy(() =>
  import("pages/introducing-broker/links")
);

const IntroducingBrokerCommissionSettings = lazy(() =>
  import("pages/introducing-broker/commission-settings")
);

const IntroducingBrokerIBCommissions = lazy(() =>
  import("pages/introducing-broker/ib-commissions")
);

const IntroducingBrokerPerformanceDashbaord = lazy(() =>
  import("pages/introducing-broker/performance-dashboard")
);

export const introducingBrokerRoutes = [
  { path: INTRODUCING_BROKER_ROUTE, element: <IntroducingBroker /> },
  { path: INTRODUCING_BROKER_APPLY_ROUTE, element: <IntroducingBrokerApply /> },
  {
    path: INTRODUCING_BROKER_DASHBOARD_ROUTE,
    element: <IntroducingBrokerDashboard />,
  },
  {
    path: INTRODUCING_BROKER_ACCOUNT_COMMISSION_ROUTE,
    element: <IntroducingBrokerAccountCommission />,
  },
  {
    path: INTRODUCING_BROKER_CLIENT_COMMISSION_ROUTE,
    element: <IntroducingBrokerClientCommission />,
  },
  {
    path: INTRODUCING_BROKER_LINKS_ROUTE,
    element: <IntroducingBrokerLinks />,
  },
  {
    path: INTRODUCING_BROKER_COMMISSION_SETTINGS_ROUTE,
    element: <IntroducingBrokerCommissionSettings />,
  },
  {
    path: INTRODUCING_BROKER_IB_COMMISSIONS_ROUTE,
    element: <IntroducingBrokerIBCommissions />,
  },
  {
    path: INTRODUCING_BROKER_PERFORMANCE_DASHBOARD_ROUTE,
    element: <IntroducingBrokerPerformanceDashbaord />,
  },
];
